<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-6">
                <router-link :to="{name: 'users'}">powrót</router-link>
              </div>
              <div class="col-sm-6 text-right">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <div>Nowy użytkownik</div>
          </div>
          <div class="card-body">
            <form @submit.prevent="createUser()">
              <div class="row">
                <div class="form-group col-md-4">
                  <label for="firstName">Imię</label>
                  <input class="form-control" id="firstName" v-model="firstName" type="text"/>
                </div>
                <div class="form-group col-md-4">
                  <label for="lastName">Nazwisko</label>
                  <input class="form-control" id="lastName" v-model="lastName" type="text"/>
                </div>
                <div class="form-group col-md-4">
                  <label for="email">E-mail</label>
                  <input class="form-control" id="email" v-model="email" type="text"/>
                </div>
                <div class="form-group col-md-4">
                  <label for="username">Login</label>
                  <input class="form-control" id="username" v-model="username" type="text"/>
                </div>
                <div class="form-group col-md-4">
                  <label for="password">Hasło</label>
                  <input class="form-control" id="password" v-model="password" type="password"/>
                </div>
                <div class="form-group col-md-4">
                  <label for="rights">Typ konta</label>
                  <select class="form-control" id="rights" v-model="rights">
                    <option value="20">{{ $t('users.permissions.20')}}</option>
                    <option value="50">{{ $t('users.permissions.50')}}</option>
                    <option value="80" v-has-permissions="81">{{ $t('users.permissions.80')}}</option>
                  </select>
                </div>
                <div class="form-group col-md-4">
                  <label for="branchId">{{ $t('branchName') }}</label>
                  <select class="form-control" id="branchId" v-model="branchId">
                    <option value="1">Malinowy Zdrój</option>
                    <option value="2">Malinowy Raj</option>
                    <option value="3">Malinowy Dwór</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-4">
                  <button type="submit" class="btn btn-primary">Dodaj użytkownika</button>
                </div>
              </div>
            </form>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import users from '@Service/users';

  export default {
    data() {
      return {
        firstName: '',
        lastName: '',
        email: '',
        username: '',
        password: '',
        rights: '20',
        branchId: '',
      };
    },
    methods: {
      createUser: function () {
        users.createUser({
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email || undefined,
          username: this.username,
          password: this.password,
          rights: this.rights,
          branchId: this.branchId,
        })
          .then(() => {
            // TODO show message
            this.$router.push({ name: 'users' });
          });
      }
    },
    mounted: function () {
    },
  };
</script>

<style scoped>
</style>
